import { Component, Input } from '@angular/core';

import { IFacet, IFacetGroup } from './facet.interface';
import { CommonModule } from '@angular/common';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { AnchorComponent } from '../anchor/anchor.component';

/**
 * Class that models the AAG Facet component.
 * This component renders a list of facet groups with its own facets.
 * Each facet group has an icon associated.
 */
@Component({
    selector: 'finder-aag-facet',
    templateUrl: './aag-facet.component.html',
    styleUrls: ['./aag-facet.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FontIconComponent,
        AnchorComponent
    ]
})

export class AagFacetComponent {
    /**
     * @example
     * [
     *      {
     *          name: "thrillFactor",
     *          icon: "thrill-seekers",
     *          clicked: false,
     *          facets: [
     *              {
     *                  id: '16669877',
     *                  name: 'Thrill Rides'
     *                  urlFriendlyId: 'thrill-rides',
     *              }, {...}
     *          ]}
     *      }, {...}
     * ]
     * @member {IFacetGroup[]} facetGroups The list of facets grouped by facet type like Age, Height, etc.
     */
    @Input() public facetGroups: IFacetGroup[];

    /**
     * @member {string} entityTypeUrl The URL to deeplink the facet with the listing page.
     */
    @Input() public entityTypeUrl: string;
}
